<template>
  <div id="order_history_detail">
    <template v-if="isDispPrice">
      <div class="input_list">
        <ul>
          <li>
            <table class="order_price_table">
              <thead>
                <tr>
                  <th>項目</th>
                  <th>単価</th>
                  <th>金額</th>
                </tr>
              </thead>
              <tbody>
                <tr class="b_separator">
                  <td>商品・配送料小計</td>
                  <td></td>
                  <td>{{formatPrice(orderPrice.itemSubTotalPrice)}}</td>
                </tr>
                <tr>
                  <td>消費税</td>
                  <td>10%</td>
                  <td>{{formatPrice(orderPrice.itemSubTotalTax)}}</td>
                </tr>
                <tr class="n_separator">
                  <td>商品・配送費合計</td>
                  <td></td>
                  <td>{{formatPrice(orderPrice.itemTotalPrice)}}</td>
                </tr>
              </tbody>
            </table>
            <table class="order_price_table" style="margin-top: 20px">
              <tbody>
                <template v-if="isConstruct">
                  <tr class="b_separator tbl_space">
                    <td>組立設置他サービス費小計</td>
                    <td></td>
                    <td>{{formatPrice(orderPrice.optSubTotalPrice)}}</td>
                  </tr>
                  <tr v-if="orderPrice.discntPrice">
                    <td>諸経費割引</td>
                    <td></td>
                    <td>(-{{formatPrice(orderPrice.discntPrice)}})</td>
                  </tr>
                  <tr class="n_separator" v-if="orderPrice.discntPrice">
                    <td>小計</td>
                    <td></td>
                    <td>{{formatPrice(orderPrice.discntSubTotalPrice)}}</td>
                  </tr>
                  <tr :class="{n_separator: orderPrice.discntPrice}">
                    <td>消費税</td>
                    <td>10%</td>
                    <td>{{formatPrice(orderPrice.optTotalTax)}}</td>
                  </tr>
                  <tr class="n_separator">
                    <td>組立設置他サービス費合計</td>
                    <td></td>
                    <td>{{formatPrice(orderPrice.optTotalPrice)}}</td>
                  </tr>
                </template>
                <tr class="b_separator">
                  <td>ご請求額合計</td>
                  <td></td>
                  <td>{{formatPrice(orderPrice.totalPrice)}}</td>
                </tr>
              </tbody>
            </table>
          </li>
        </ul>
      </div>
    </template>
    <template v-else>
      <div class="price_list total_price">
        <ul>
          <li>
            <div>ご請求額合計</div>
            <div>￥-----------</div>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'OrderPrice',
  components: {
  },
  props: {
    orderPrice: Object,
    isDispPrice: {
      type: Boolean,
      default: true
    },
    isConstruct: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    }
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../css/dc-cart.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.price_area {
  margin: 2rem 0;
  background: #ffffff;
  color: #000000;
  border: 0.1rem solid #ccc;
  border-radius: 0.5rem;
}
.n_separator {
  border-top: 0.1rem solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/components/payment/DcOrderPrice.vue